<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="50" width="50" viewBox="0 0 640 480">
        <g fill-rule="evenodd" stroke-width="1pt">
            <path fill="#fff" d="M0 0h640v479.997H0z"/>
            <path fill="#009246" d="M0 0h213.331v479.997H0z"/>
            <path fill="#ce2b37" d="M426.663 0h213.331v479.997H426.663z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "It"
    }
</script>

<style scoped>

</style>
